/**
 * TB学堂路由
 */
const routerSchool = {
  path: '/lesson',
  redirect: '/lesson/online-course',
  name: 'SchoolMain',
  meta: {
    title: '数智课堂',
    needLogin: false,
    transitionName: 'router',
    isTopMenu: true,
    isFatherMenu: true,
    isHot: true,
  },
  component: () => import('@/pages/module-school/index.vue'),
  children: [
    {
      path: 'online-course',
      name: 'School',
      meta: {
        title: '在线课程',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
        intro: '在线课程',
        icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-13.png',
      },
      // component: () => import('@/pages/module-school/School.vue'),
      component: () => import('@/pages/module-school/SchoolCourseList.vue'),
    },
    {
      path: 'online-course-list',
      name: 'SchoolCourseList',
      meta: {
        title: '课程列表',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-school/SchoolCourseList.vue'),
    },
    {
      path: 'online-short-course',
      name: 'SchoolShortCourse',
      meta: {
        title: '大咖三分钟',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-school/SchoolShortList.vue'),
    },
    {
      path: 'online-course-detail/:id',
      name: 'SchoolCourseDetail',
      meta: {
        title: '课程详情',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-school/SchoolCourseDetail.vue'),
    },
    {
      path: 'online-course-exam',
      name: 'SchoolCourseExam',
      meta: {
        title: '考试',
        needLogin: true,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-school/SchoolCourseExam.vue'),
    },
    {
      path: 'online-course-video/:type/:id',
      name: 'SchoolCourseVideo',
      meta: {
        title: '课程视频',
        needLogin: true,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-school/SchoolCourseVideo.vue'),
    },
    {
      path: 'lecturer/:id',
      name: 'SchoolLecturer',
      meta: {
        title: '讲师主页',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-school/SchoolLecturer.vue'),
    },
    {
      path: 'practical-camp',
      name: 'TeacherCampPractical',
      meta: {
        title: '能力特训',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
      },
      component: () => import('@/pages/module-teacher-camp/TeacherCampHome.vue'),
    },
    {
      path: 'teacher-camp-register/:id',
      name: 'TeacherCampRegister',
      meta: {
        title: '特训营详情',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-teacher-camp/TeacherCampCamp.vue'),
    },
    {
      path: 'teacher-camp-detail/:id',
      name: 'TeacherCampDetail',
      meta: {
        title: '特训营详情',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-teacher-camp/TeacherCampDetail.vue'),
    },
  ],
};

export default routerSchool;
